import React from 'react';
import AppRoutes from './routes/AppRoutes';

function App() {
  return <div id='dummy' style={{ padding:0, minHeight: '100vh', width: '100%' }}> <AppRoutes /> </div>;
}

export default App;
